import type { ProAdminRefundApprovalDto, ProAdminRefundDecisionInput } from "@dutyon/apis";
import { prepareRejection } from "./reject-model.ts";

export function prepareApproval(reason: string, revision: number): ProAdminRefundDecisionInput {
  try {
    return prepareRejection(reason, revision);
  } catch {
    throw new Error("승인 사유를 1~1,000자로 입력하고 최신 요청을 확인해 주세요.");
  }
}
export function readApproval(
  value: unknown,
  id: string,
  input: ProAdminRefundDecisionInput,
  maximumAmount: number,
): ProAdminRefundApprovalDto {
  const fail = () => {
    throw new Error("승인 결과를 확인하지 못했습니다.");
  };
  if (!value || typeof value !== "object" || Array.isArray(value)) return fail();
  const data = value as ProAdminRefundApprovalDto;
  const validId = (v: unknown) => typeof v === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(v);
  if (
    !validId(data.id) ||
    !validId(data.intentId) ||
    data.requestId !== id ||
    data.status !== "APPROVED" ||
    data.revision !== input.expectedRevision + 1 ||
    data.reason !== input.reason ||
    !Number.isSafeInteger(maximumAmount) ||
    maximumAmount < 1 ||
    !Number.isSafeInteger(data.amount) ||
    data.amount < 1 ||
    data.amount > maximumAmount ||
    data.currency !== "KRW" ||
    typeof data.decidedAt !== "string" ||
    !Number.isFinite(Date.parse(data.decidedAt)) ||
    new Date(data.decidedAt).toISOString() !== data.decidedAt
  )
    return fail();
  return data;
}
